






































































































import Vue from "vue";
import Processing from "@/components/table/Processing.vue";
import Spinner from "@/components/Spinner.vue";
import EmbedHtml from "@/components/EmbedHtml.vue";
export default Vue.extend({
  components: {
    Processing,
    Spinner,
    EmbedHtml,
  },
  props: [
    "title",
    "desc",
    "details",
    "mitigation",
    "threats",
    "is_policy_active",
    "is_loading",
    "show_activate_btn_loader",
  ],
});
